// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import React from 'react'

const Ellipsis = () => (
  <>
    <i className={'fa fa-circle'} />
    <i className={'fa fa-circle'} />
    <i className={'fa fa-circle'} />
  </>
)

export default Ellipsis
